import commonSetting from '@/config/commonSetting';
import api from '@/services/api/index';
import {Dialog, Toast} from 'antd-mobile';
import { Base64 } from 'js-base64';
import { createBrowserHistory } from 'history';
import qs from 'qs';


const browserHistory = createBrowserHistory();

function getMarketIdByRegex(stockCode) {
  const regexToMarketId = [
    { regex: /^(00)\d{4}\.SH$/, marketId: 0 },
    { regex: /^(60)\d{4}\.SH$/, marketId: 1 },
    { regex: /^(68)\d{4}\.SH/, marketId: 7 },
    { regex: /^(39)\d{4}\.SZ$/, marketId: 1000 },
    { regex: /^(00)\d{4}\.SZ$/, marketId: 1001 },
    { regex: /^(30)\d{4}\.SZ$/, marketId: 1008 },
  ];
  for (const item of regexToMarketId) {
    if (item.regex.test(stockCode)) {
      return item.marketId;
    }
  }
}
// 指数
function getExchangeIndex(stockCode) {
  if (!stockCode) return;
  const tail = stockCode.split('.')[1];
  if (tail === 'SH') {
    return 0;
  } else {
    return 1;
  }
}
// 个股
function getExchange(stockCode) {
  if (stockCode.startsWith('6')) {
    return 0;
  } else if (stockCode.startsWith('0') || stockCode.startsWith('3')) {
    return 1;
  } else {

  }
}

function marketIdToMarketName(marketId) {
  switch (marketId) {
    case 0:
      return 'SH';
    case 1:
      return 'SH';
    case 7:
      return 'SH';
    case 1000:
      return 'SZ';
    case 1001:
      return 'SZ';
    case 1008:
      return 'SZ';
  }
}

/**
 * param {Number} num 数值
 * param {Number} len 小数位的个数（几位小数）
 */
const keepDecimal = function (num, len) {
  // 将数值转浮点数
  let result = parseFloat(num);
  // 默认保留一位小数
  len = len || 1;
   	if (isNaN(result)) {
    return 0;
  }
  result = Math.round(num * Math.pow(10, len)) / Math.pow(10, len);
  const arrNum = result.toString().split('.');
  if (arrNum.length == 1) {
    return `${result.toString()}.00`;
  }
  if (arrNum.length > 1) {
    // 小数点右侧 如果小于两位 则补一个0
    if (arrNum[1].length < 2) {
      return `${result.toString()}0`;
    }
    return result;
  }
  	return result;
};

const keepMaxChangeDecimal = function (num, len) {
  // 将数值转浮点数
  let result = parseFloat(num);

  // 默认保留一位小数
  len = len || 1;
  if (isNaN(result)) {
    return 0;
  }
  result = num * Math.pow(10, len);
  const arrNum = result.toString().split('.');
  if (arrNum.length == 1) {
    return `${result.toString()}.00`;
  }
  if (arrNum.length > 1) {
    // 小数点右侧 如果小于两位 则补一个0
    if (arrNum[1].length < 2) {
      return `${result.toString()}0`;
    }
    return result;
  }
  return result;
};
const replactTag = (value) => {
  if (!value) {
    return;
  }
  const codeVal = value.slice(0, 2);
  const endVal = value.split('.');
  // console.log(endVal, 'endend');
  let obj = {};
  if (endVal[1]) {
    if (endVal[1] == 'SH') {
      obj = {
        tag: '沪',
        fontColor: '#FA5151',
        tagColor: '#fadbdc',
      };
    } else if (endVal[1] == 'SZ') {
      obj = {
        tag: '深',
        fontColor: '#3662EC',
        tagColor: '#CDE1FD',
      };
    }
  }
  switch (codeVal) {
    // case '60' :
    //     obj = {
    //         tag: '沪',
    //         fontColor: '#FA5151',
    //         tagColor: '#FCDBDB'
    //     }
    //     break
    case '68':
      obj = {
        tag: '科',
        fontColor: '#3662EC',
        tagColor: '#CDE1FD',
      };
      break;
      // case '00' :
      //     obj = {
      //         tag: '深',
      //         fontColor: '#3662EC',
      //         tagColor: '#CDE1FD'
      //     }
      //     break
    case '30':
      obj = {
        tag: '创',
        fontColor: '#FFC300',
        tagColor: '#FFFBE1',
      };
      break;
  }
  return obj;
};
const marketToTag = (value) => {
  let obj = {}
  if (typeof value !== 'number') {
    return;
  }
  const marketValue = value.toString()
  // debugger
  switch (marketValue) {
    case '0':
      obj = {
        tag: '沪',
        fontColor: '#FA5151;',
        tagColor: 'rgba(250, 81, 81, 0.2)',
        fontSize: '20rpx',
        width: '28rpx',
        height: '28rpx'
      }
      break
    case '1':
      obj = {
        tag: '沪',
        fontColor: '#FA5151;',
        tagColor: 'rgba(250, 81, 81, 0.2)',
        fontSize: '20rpx',
        width: '28rpx',
        height: '28rpx'
      }
      break
    case '7':
      obj = {
        tag: '科',
        fontColor: '#1677FF;',
        tagColor: 'rgba(22, 119, 255, 0.2)',
        fontSize: '20rpx',
        width: '28rpx',
        height: '28rpx'
      };
      break;
    case '1000':
      obj = {
        tag: '深',
        fontColor: '#FA5151;',
        tagColor: 'rgba(250, 81, 81, 0.2)',
        fontSize: '20rpx',
        width: '28rpx',
        height: '28rpx'
      }
      break
    case '1001':
      obj = {
        tag: '深',
        fontColor: '#FA5151;',
        tagColor: 'rgba(250, 81, 81, 0.2)',
        fontSize: '20rpx',
        width: '28rpx',
        height: '28rpx'
      }
      break
    case '1008':
      obj = {
        tag: '创',
        fontColor: '#FF8F1F;',
        tagColor: 'rgba(255, 143, 31, 0.2)',
        fontSize: '20rpx',
        width: '28rpx',
        height: '28rpx'
      };
      break;
  }
  return obj;
};
const numberFormat = (value, toFixedNumber) => {
  if (!value) return 0;
  let num = '';
  let unit = '';
  const k = 10000;
  const sizes = ['', '万', '亿', '万亿'];
  let i;
  if (value < k) {
    num = value;
    unit = '';
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    num = ((value / Math.pow(k, i))).toFixed(toFixedNumber || 1);
    unit = sizes[i];
  }
  return num + unit;
};
const numberHandle = (value) => {
  if (!value) return 0;
  let num = '';
  let unit = '';
  const k = 10000;
  const sizes = ['', '万', '亿', '万亿'];
  let i;
  if (value < k) {
    num = value;
    unit = '';
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    num = ((value / Math.pow(k, i))).toFixed(1);
    unit = sizes[i];
  }
  return num + unit;
};
const formatNumberHandle = (value) => {
  if (!value && value !== 0) return '--';
  let num = '';
  let unit = '';
  const k = 10000;
  const sizes = ['元', '万', '亿', '万亿'];
  const isNegative = value < 0;
  value = Math.abs(value);
  let i;

  if (value < k) {
    num = (Math.round(value * 100) / 100).toFixed(2);
    unit = sizes[0]; // 确保 0 也有单位 '元'
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    num = (Math.round((value / Math.pow(k, i)) * 100) / 100).toFixed(2);
    unit = sizes[i];
  }

  // 处理 -0.00 的情况
  if (num === '-0.00') {
    num = '0.00';
  }

  if (isNegative) {
    num = `-${num}`;
  }

  return { num, unit };
};
const toThousand = (value) => {
  if (!value) return 0;
  let num = '';
  let unit = '';
  if (value < 1000) {
    num = value;
    unit = '';
  } else {
    num = (value / 1000).toFixed(3);
    unit = 'K';
  }
  return num + unit;
};
const replaceTopic = (value) => {
  const TopColorMap = {
    '#仓位#': '#FF8F1F',
    '#策略#': '#FF8F1F',
    '#焦点#': '#FF8F1F',
    '#教学#': '#5856D6',
    '#大盘#': '#5856D6',
    '#板块#': '#5856D6',
  };
  if (!value) {
    return;
  }
  let r;
  r = value.replace(/[#＃][^#＃]+[#＃]/g, (word) => {
    return `<a style="color:${TopColorMap[word] ? TopColorMap[word] : '#1677FF'}" class="topic">${word}</a>`;
  });
  return r;
};
const replaceText = (value) => {
  if (value) {
    return value.replace(/([A-Za-z0-9]{3})[A-Za-z0-9]{4}([A-Za-z0-9]{4})/g, '$1****$2');
  }
};
const fetchUserInfo = async () => {
  try {
    const resp = await api.userController.usersMeUsingGET();
    const userInfo = resp.data;
    return userInfo;
  } catch (error) {
    console.log(error);
    return null;
  }
};
const getWxAuthorizationUrl = async (path, productType, scope) => {
  // return
  const params = {
    companyType: commonSetting.COMPANY_TYPE,
    productType,
    scope: scope || 'snsapi_base',
    path,
  };
  const resp = await api.wxOauth2Controller.wxOauth2UrlUsingGET(params);
  debugger;
  if (resp.code == 0) {
    return resp.data;
  } else {
    console.log('授权链接获取失败:', resp.code);
    return null;
  }
};
const n2oLink = async (origin, path) => {
  debugger;
  location.href = `${origin}n2o?path=${encodeURIComponent(path)}&accountType=${localStorage.getItem('accountType')}&openId=${localStorage.getItem('openId')}&wxId=${localStorage.getItem('wxId')}`;
};
const redirectWxAuthorizationUrl = async (path, productType, scope) => {
  // return
  if (path.startsWith('/redirect')) {
    Toast.show({
      icon: 'fail',
      content: '授权错误',
    });
    return;
  }
  const url = await getWxAuthorizationUrl(encodeURIComponent(path), productType, scope);
  if (url) {
    location.replace(url);
  } else {
    Toast.show({
      icon: 'fail',
      content: '未知错误',
    });
  }
};

const redirectProduct = async (domain) => {
  const url = domain;
  location.replace(url);
};
// 静态资源路劲
const fileUrlFilter = (url) => {
  if (url) {
    if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
      return url;
    } else {
      return `https://tj-file-oss.cf69.com/${url}`;
    }
  } else {
    return url;
  }
};

const hasKeyInArr = (arr, key, val) => {
  for (const arrKey in arr) {
    if (arr[arrKey][key] === val) {
      return arr[arrKey];
    }
  }
  return false;
};

const parseAlign = (columns, direction) => {
  return columns.map((item) => ({ ...item, align: direction }));
};

const reqUploadTrackEvent = async (category, action, label, _wxId) => {
  const accessToken = localStorage.getItem('accessToken');
  let wxId;
  if (accessToken) {
    wxId = JSON.parse(Base64.decode(accessToken.split('.')[1]))?.wxId;
  }
  if (!wxId && !_wxId) {
    return;
  }
  const params = {
    category,
    action,
    label,
    number: localStorage.getItem('salesNumber'),
    wxId: _wxId || wxId,
  };
  const resp = await api.wxTrackController.userWxTrackWxIdUsingPOST(params);
  if (resp.code == 0) {
    return resp.data;
  } else {
    console.log('授权链接获取失败:', resp.code);
    return null;
  }
};
const reqUploadTrackEventCNZZ = async (category, action, label, cb) => {
  console.log('window._czc', window._czc);
  window._czc && window._czc.push(['_trackEvent', category, action, label]);
  if (cb) {
    setTimeout(() => {
      cb();
    }, 100);
  }
};
const customNumber = (value) => {
  return value != null ? value.toFixed(2) : '--'; // convert to int
};
const stockClass = (val, toFixedNum) => {
  if (toFixedNum) {
    val = Number(val.toFixed(toFixedNum));
  }
  if (val === 'NaN') return;
  return val ? val > 0 ? 'stock-red' : 'stock-green' : '';
};
const stockBorderClass = (val, toFixedNum) => {
  if (toFixedNum) {
    val = Number(val.toFixed(toFixedNum));
  }
  if (val === 'NaN') return;
  return val ? val > 0 ? 'stock-red-border' : 'stock-green-border' : '';
};
const replaceId = (id) => {
  if (!id) {
    return '';
  }
  const str = `${id}`;
  const map = {
    0: 'J',
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D',
    5: 'E',
    6: 'F',
    7: 'G',
    8: 'H',
    9: 'I',
  };
  return str.split('').map((item) => map[item]).join('');
};
const numberChinese = (number) => {
  const units = '个十百千万@#%亿^&~'; const
    chars = '零一二三四五六七八九';
  const a = (`${number}`).split(''); const
    s = [];
  if (a.length > 12) {
    throw new Error('too big');
  } else {
    for (var i = 0, j = a.length - 1; i <= j; i++) {
      if (j == 1 || j == 5 || j == 9) { // 两位数 处理特殊的 1*
        if (i == 0) {
          if (a[i] != '1') s.push(chars.charAt(a[i]));
        } else {
          s.push(chars.charAt(a[i]));
        }
      } else {
        s.push(chars.charAt(a[i]));
      }
      if (i != j) {
        s.push(units.charAt(j - i));
      }
    }
  }
  // return s;
  return s.join('').replace(/零([十百千万亿@#%^&~])/g, (m, d, b) => { // 优先处理 零百 零千 等
    b = units.indexOf(d);
    if (b != -1) {
      if (d == '亿') return d;
      if (d == '万') return d;
      if (a[j - b] == '0') return '零';
    }
    return '';
  }).replace(/零+/g, '零').replace(/零([万亿])/g, (m, b) => { // 零百 零千处理后 可能出现 零零相连的 再处理结尾为零的
    return b;
  })
    .replace(/亿[万千百]/g, '亿')
    .replace(/[零]$/, '')
    .replace(/[@#%^&~]/g, (m) => {
      return { '@': '十', '#': '百', '%': '千', '^': '十', '&': '百', '~': '千' }[m];
    })
    .replace(/([亿万])([一-九])/g, (m, d, b, c) => {
      c = units.indexOf(d);
      if (c != -1) {
        if (a[j - c] == '0') return `${d}零${b}`;
      }
      return m;
    });
};

// 个人中心去注册
const goRegister = () => {
  const params = {
    accessToken: localStorage.getItem('accessToken'),
    salesId: localStorage.getItem('salesId'),
    salesNumber: localStorage.getItem('salesNumber'),
    refreshToken: localStorage.getItem('refreshToken') || '',
    source: '产品',
    productType: commonSetting.PRODUCT_TYPE,
  };
  const query = `params=${encodeURIComponent(JSON.stringify(params))}`;
  window.location.href = `${commonSetting.GC_ACCESS_URL}redirect?path=/survey?redirect=${encodeURIComponent(`${window.location.origin}/userCenter`)}&${query}&open_id=${localStorage.getItem('openId') || ''}&wxId=${localStorage.getItem('wxId') || ''}`;
};

const customerTrackUpload = async (pageId, category, action, label) => {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const salesNumber = query.salesNumber||localStorage.getItem('salesNumber');
  const params = {
    pageId, // 页面id
    appId: 'prod', // 应用id
    category, // 事件
    action, // 行为
    label, // 具体描述
    url: window.location.href, //
    number: salesNumber
  };

  try {
    await api.customerTrackController.userCustomerTrackUploadEnvenUsingPOST(params);
  } catch (error) {
    console.log(error);
  }
};

const customerHeartbeat = async (pageId) => {
  const token = localStorage.getItem('accessToken')
  if (!token) {
    return;
  }
  const params = {
    pageId, // 页面id
    appId: 'prod', // 应用id
  };
  try {
    await api.customerTrackController.userCustomerTrackUploadHeartbeatUsingPOST(params);
  } catch (error) {
    console.log(error);
  }
};
const flatten = (ary) => {
  return ary.reduce((pre, cur) => {
    return pre.concat(Array.isArray(cur) ? flatten(cur) : cur);
  }, []);
};
const formatTenThousand = (value) => {
  if (!value) return 0;
  let num = '';
  let unit = '';
  if (Math.abs(value) >= 100000000) {
    num = (value / 100000000).toFixed(2);
    unit = '亿';
  } else {
    num = Math.round(value / 10000);
    unit = '万';
  }
  return num + unit;
};
// 注册认证测评
const getUserCertification = async () => {
  const reps = await api.userController.usersCertificationUsingGET();
  if (reps.code === 0 && reps?.data) {
    const flag = !reps.data.isCertified || !reps.data.isEvaluated || !reps.data.isRegistered;
    localStorage.setItem('certification', JSON.stringify(reps?.data));
    if (flag) {
      window.location.href = `${window.location.origin}/warn`;
    }
  }
};
const getTextWidth = (text) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = '10px D-DIN';
  const { width } = context.measureText(text);
  return width;
};

// 红涨绿跌平灰
const handleColor = (now, last) => {
  if (now > last) {
    return '#FA5151';
  } else if (now < last) {
    return '#00B578';
  } else {
    return '#999999';
  }
};
function formatTimestamp(timestamp) {
  const date = new Date(timestamp); // 将时间戳转为 Date 对象

  // 加 8 小时
  date.setHours(date.getHours() + 8);

  // 获取 UTC 年、月、日、小时和分钟
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 月份从0开始，需加1并补零
  const day = String(date.getUTCDate()).padStart(2, '0');
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  // 返回格式化后的字符串
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}
const replaceTime = (dateString) => {
  const datePart = dateString.split(' ')[0];
  const hmsPart = dateString.split(' ')[1];

  let [year, month, day] = datePart.split('-');
  let [hour, minute, second] = hmsPart.split(':');
  month = month.padStart(2, '0');
  day = day.padStart(2, '0');
  hour = hour.padStart(2, '0');
  minute = minute.padStart(2, '0');
  second = second.padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};
const getExchangeId = (code) => {
  const exchange = code.split('.')[1];
  // debugger
  if (exchange === 'SH') {
    return 0;
  } else {
    return 1;
  }
};

const renderFreshText = (status) => {
  const statusMap = {
    pulling: '下拉刷新',
    canRelease: '释放刷新',
    refreshing: '刷新中...',
    complete: '刷新成功',
  };
  const aniGif = require('@/assets/images/jcj_loading.gif');
  const staGif = require('@/assets/images/jcj_loading.png');
  return (
    <div
      className={'custom-refresh-top'}
      style={{ display: 'flex',
        justifyContent: 'center',
        alignItems: 'center' }}
    >
      <img style={{ width: '22px', height: '22px', marginRight: '10px' }} src={status === 'refreshing' ? aniGif : staGif} />
      {statusMap[status] || '刷新中'}
    </div>
  );
};

const getImageStyle = (naturalWidth, naturalHeight) => {
  let width = 0;
  let height = 0;
  const ratio = naturalWidth / naturalHeight;
  if (ratio == 1) {
    width = 250;
    height = 250;
  } else if (ratio >= 3) {
    width = 250;
    height = 250;
  } else if (ratio > 1 && ratio < 3) {
    width = 250;
    height = 250 * naturalHeight / naturalWidth;
  } else if (ratio > 1 / 3 && ratio < 1) {
    width = 250 * naturalWidth / naturalHeight;
    height = 250;
  } else if (ratio <= 1 / 3) {
    width = 250;
    height = 250;
  }
  return { width, height };
};
const fillMissingMinutes = (data) => {
  if (!Array.isArray(data) || data.length === 0) return []

  const dataMap = new Map(data.map(d => [d[0], d]))
  const result = []

  const allIds = data.map(d => d[0])
  const maxId = Math.max(...allIds)
  const minId = Math.min(...allIds)

  const firstValid = dataMap.get(minId)
  let lastValid = null

  for (let i = 90; i <= maxId; i++) {
    if (i >= 211 && i <= 299) continue

    let current

    if (dataMap.has(i)) {
      current = dataMap.get(i)
    } else if (i < minId && firstValid) {
      // 用第一个有效数据补前面的
      current = [i, ...firstValid.slice(1)]
    } else if (lastValid) {
      // 用上一条有效数据补后面的
      current = [i, ...lastValid.slice(1)]
    }

    if (current) {
      result.push(current)
      lastValid = current
    }
  }

  return result
}
function isStrictNumeric(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value)
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const num = Number(value)
    return Number.isFinite(num)
  }
  return false
}
const getRootDomain = (hostname) => {
  const domainParts = hostname.split('.');

  if (domainParts.length <= 2) {
    return hostname;
  }

  const tld = domainParts.slice(-2).join('.');
  return tld;
};
// 处理股票格式 000001.SH 转换为 000001
const formatLabel = (code) => {
    // 检查输入是否是字符串并包含小数点
    if (typeof code === 'string' && code.includes('.')) {
        return code.split('.')[0];
    }
    return code; // 如果不符合格式，原样返回
}
const getStockDetailPath = (label) => {
  let reg = /^00\d{4}\.SH|^39\d{4}\.SZ/;
  let path = ''
  if(reg.test(label)){
    path = `/mini-program/index-detail?labelCode=${label}`;
  } else {
    path = `/mini-program/stock-detail?labelCode=${label}`;
  }
  return path
}
const getWxMaSchema = (accountType, path, query) => {
  return new Promise(async (resolve, reject) => {
    const resp = await api.pubController.publicWxMaSchemaUsingPOST({
      isExpire: true,
      accountType,
      envVersion: ENV === 'prod' ? 'release' : 'trial',
      path,
      query,
    });
    debugger
    if (resp?.code === 0) {
      resolve(resp?.data);
    } else {

      reject(resp?.msg);
    }
  });
};

const registeredInMini = (path, productType, scope,source) => {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const salesNumber = query?.salesNumber||localStorage.getItem('salesNumber')||'';
  Dialog.alert({
    title: '温馨提示',
    content: <>
      <p style={{ textAlign: 'center', fontSize: '16px', color: 'rgba(0,0,0,0.6)' }}>为了更好地为您提供服务，请前往</p>
      <p style={{ textAlign: 'center', fontSize: '16px', color: 'rgba(0,0,0,0.6)' }}>小程序进行手机号绑定</p>
    </>,
    confirmText: '点击前往小程序',
    onConfirm: () => {
      let wxMaSchemaFn;
      const accountType = ENV === 'prod' ? 20103 : 20100;
      // const wxPath = 'packageB/pages/register/register';
      const wxPath = 'packageB/pages/register/register';
      const wxQuery = `source=${encodeURIComponent(source || '产品(小程序)')}&salesNumber=${salesNumber}`;
      wxMaSchemaFn = getWxMaSchema(accountType, wxPath, wxQuery);
      wxMaSchemaFn.then((url) => {
        window.location.href = url;
        setTimeout(() => {
          Dialog.show({
            title: '温馨提示',
            content:<>
              <p style={{ textAlign: 'center', fontSize: '16px', color: 'rgba(0,0,0,0.6)'}}>已检测到您的页面信息有更新，</p>
              <p style={{ textAlign: 'center', fontSize: '16px', color: 'rgba(0,0,0,0.6)'}}>请点击刷新按钮重新进入</p>
            </>,
            closeOnAction: true,
            actions: [
              [
                {
                  key: 'refresh',
                  text: '刷新',
                  onClick: () => {
                    redirectWxAuthorizationUrl(path, productType, scope)
                  }
                },
              ],
            ],
          })
        },500)

      }).catch((err) => {
        Toast.show({ content: '获取链接失败，无法跳转' });
      });
    },
  });

};
const navigateToMiniProgramPage = (url)=> {
  if (window.wx && window.wx.miniProgram) {
    window.wx.miniProgram.navigateTo({
      url: url, // 这是小程序的内部路径
      success: function() {
        console.log('跳转成功');
      },
      fail: function(error) {
        console.error('跳转失败:', error);
      }
    });

  } else {
    Toast.show({ content: '跳转小程序页面失败' })
    console.error('wx.miniProgram 对象不存在，可能不在 web-view 环境中或 JSSDK未加载');
  }
}
const getPriceChangeColor = (value) => {
        if (value > 0) {
            return '#FF3141'; // 涨红色
        } else if (value < 0) {
            return '#00B578'; // 跌绿色
        } else {
            return '#888888'; // 平灰色
        }
    };
    const formatValue = (value,add) => {
        if (typeof value !== 'number') {
            return
        }
        const formattedValue = (value*100).toFixed(2); // 格式化为两位小数
        const sign = (value >= 0&&add)? '+' : ''; // 如果值大于等于0，则添加加号

        return `${sign}${formattedValue}%`; // 返回带有符号的百分比字符串
    };
export default {
  formatValue,
  getPriceChangeColor,
  getStockDetailPath,
  isStrictNumeric,
  browserHistory,
  keepDecimal,
  keepMaxChangeDecimal,
  replaceTopic,
  replaceText,
  n2oLink,
  parseAlign,
  fetchUserInfo,
  redirectProduct,
  getWxAuthorizationUrl,
  redirectWxAuthorizationUrl,
  hasKeyInArr,
  reqUploadTrackEvent,
  reqUploadTrackEventCNZZ,
  stockClass,
  stockBorderClass,
  customNumber,
  numberChinese,
  fileUrlFilter,
  replaceId,
  replactTag,
  toThousand,
  numberFormat,
  goRegister,
  customerTrackUpload,
  customerHeartbeat,
  flatten,
  getUserCertification,
  numberHandle,
  formatNumberHandle,
  getMarketIdByRegex,
  marketIdToMarketName,
  getExchange,
  getTextWidth,
  formatTenThousand,
  handleColor,
  formatTimestamp,
  replaceTime,
  getExchangeId,
  getRootDomain,
  getExchangeIndex,
  renderFreshText,
  getImageStyle,
  formatLabel,
  fillMissingMinutes,
  marketToTag,
  getWxMaSchema,
  registeredInMini,
  navigateToMiniProgramPage
};
